import React, { useState, useEffect } from "react";
import { Tooltip } from "@mui/material";
import { MobileHeader } from "assets/css/globle";
import { SearchIcon } from "assets/svgIcons";
import ThreeDotIcon from "assets/svgIcons/ThreeDotsIcon";
import IconButton from "@mui/material/IconButton";
import SiteMapIcon from "assets/svgIcons/MapIcon";
import FullScreenMapIcon from "assets/svgIcons/FullMapIcon";
import FlagIcon from "assets/svgIcons/FlagIcon";
import PhotoIcon from "assets/svgIcons/CameraIcon";
import { useHookstate } from "@hookstate/core";
import IconDetailsIcon from "assets/svgIcons/IconDetailIcon";
import SettingDownIcon from "assets/svgIcons/SettingIcon";
import { useTranslation } from "react-i18next";
import {
  MAP_GLOBAL_STATES,
  SIDENAV_GLOBAL_STATE,
  SITELOCATION_GLOBAL_STATE,
  SITEID_GLOBAL_STATE
} from "globalStore/globalStore";
import { isUserAdmin } from "../../constant";
import {  useSelector } from "react-redux";
import MountainIcon from "assets/svgIcons/MapSubSIdeNav/MountainIcon";

const MapMobileMenu = ({
  site,
  zoomToShowAll,
  setZoomToShowAll,
  setSite,
  showHoleMarker,
  toggleShowHoleMarker,
  handleOpen2,
  handleToggle,
  kmlLayerData,
}) => {
  const {
    getUserRole
  } = useSelector((state) => state.commonReducers) || [];
  
  const { siteLocationGlobalData } = useHookstate(SITELOCATION_GLOBAL_STATE);
  const { sideDrawerState } = useHookstate(SIDENAV_GLOBAL_STATE);
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

  const { overlay, heightMapToggle } = useHookstate(MAP_GLOBAL_STATES);
  const { t } = useTranslation();
  const [threeDotState, setThreeDotState] = useState(false);
  const [showHeightMap, setShowHeightMap] = useState(false);

  useEffect(() => {
    if (JSON.parse(localStorage.getItem("courseOverlay")) === null || undefined) {
      overlay.set(false);
      localStorage.setItem("courseOverlay", JSON.stringify(false));
    }
    let overlayState = JSON.parse(localStorage.getItem("courseOverlay"));

    overlay.set(overlayState);
  }, [JSON.parse(localStorage.getItem("courseOverlay"))]);

  useEffect(() => {
    heightMapToggle.set(false);
    setShowHeightMap(false);
  }, [siteId.get()]);

  const handleHeightMap = () => {
    heightMapToggle.set(true);
    setShowHeightMap((prev) => !prev);
  }

  return (
    <MobileHeader>
      <h4>{t("Map")}</h4>
      <IconButton onClick={() => setThreeDotState(!threeDotState)}>
        <ThreeDotIcon
          color="#fff"
          width={3.19}
          height={14.36}        
        />
      </IconButton>

      {threeDotState && (
        <div className="open-section">
          {!siteLocationGlobalData.get() ? (
            <>
              <Tooltip title={t("Zoom_to_show_all")} arrow>
                <button
                  className="tags"
                  style={{
                    background: zoomToShowAll
                      ? "var(--selected-btn-bg)"
                      : "var(--unselect-btn-bg)",
                  }}
                  onClick={() => {
                    setZoomToShowAll(true);
                    setSite(false);
                  }}
                >
                  <SearchIcon
                    color={zoomToShowAll ? "var(--theme-text)" : "var(--text-primary)"}
                  />
                </button>
              </Tooltip>
              <Tooltip title={t("Zoom_to_site_extents")} arrow>
                <button
                  className="tags"
                  style={{
                    background: site
                      ? "var(--selected-btn-bg)"
                      : "var(--unselect-btn-bg)",
                  }}
                  onClick={() => {
                    setSite(true);
                    setZoomToShowAll(false);
                  }}
                >
                  <SiteMapIcon
                    color={site ? "var(--theme-text)" : "var(--text-primary)"}
                  />
                </button>
              </Tooltip>
              <Tooltip title={t("Full_screen")} arrow>
                <button
                  className="tags"
                  style={{
                    background: !sideDrawerState.get()
                      ? "var(--selected-btn-bg)"
                      : "var(--unselect-btn-bg)",
                  }}
                  onClick={() => sideDrawerState.set(!sideDrawerState.get())}
                >
                  <FullScreenMapIcon
                    color={
                      !sideDrawerState.get()
                        ? "var(--theme-text)"
                        : "var(--text-primary)"
                    }
                  />
                </button>
              </Tooltip>
              <Tooltip title="Show hole markers" arrow>
                <button
                  className="tags"
                  style={{
                    background: showHoleMarker
                      ? "var(--selected-btn-bg)"
                      : "var(--unselect-btn-bg)",
                  }}
                  onClick={toggleShowHoleMarker}
                >
                  <FlagIcon
                    color={
                      showHoleMarker
                        ? "var(--theme-text)"
                        : "var(--text-primary)"
                    }
                  />
                </button>
              </Tooltip>

              {kmlLayerData && kmlLayerData !== "" ? (
                <Tooltip title="Course overlay" arrow>
                  <button
                    className="tags"
                    style={{
                      background: overlay.get()
                        ? "var(--selected-btn-bg)"
                        : "var(--unselect-btn-bg)",
                    }}
                    onClick={() => {
                      overlay.set((prevState) => !prevState);
                      localStorage.setItem(
                        "courseOverlay",
                        JSON.stringify(overlay.get())
                      );
                    }}
                  >
                    <PhotoIcon
                      color={
                        overlay.get()
                          ? "var(--theme-text)"
                          : "var(--text-primary)"
                      }
                    />
                  </button>
                </Tooltip>
              ) : (
                <></>
              )}

            {isUserAdmin(getUserRole && getUserRole?.Role) &&
              <Tooltip title={t("Height_Map")} arrow>
                  <button
                    className="tags"
                    style={{
                      background: showHeightMap
                        ? "var(--selected-btn-bg)"
                        : "var(--unselect-btn-bg)",
                    }}
                    onClick={() => { handleHeightMap()
                    }}
                  >
                    <MountainIcon
                      width={30}
                      height={30}
                      color={
                        showHeightMap
                          ? "var(--theme-text)"
                          : "var(--text-primary)"
                      }
                    />
                  </button>
              </Tooltip>
            }
            </>
          ) : null}
          {siteLocationGlobalData.get() ? (
            ""
          ) : (
            <>
              <Tooltip title={t("Map_legend")} arrow>
                <span className="setting-icon" onClick={(e) => handleOpen2(e)}>
                  <IconDetailsIcon color="#1d1d1d" />
                </span>
              </Tooltip>
              <Tooltip title={t("Car_List")} arrow>
                <span className="setting-icon" onClick={handleToggle}>
                  <SettingDownIcon />
                </span>
              </Tooltip>
            </>
          )}
        </div>
      )}
    </MobileHeader>
  );
};

export default MapMobileMenu;
